// Centralised MUI sx style objects shared across all delivery components.
// Exported as getter functions rather than static objects for consistency,
// so a future token needing re-evaluation on theme change is a drop-in change.
import { tokens } from "../../theme";

/** Primary action button used across every phase. */
export const actionBtnSx = {
  width: { xs: "100%", sm: "auto" },
  minWidth: 160,
  maxWidth: 220,
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 700,
  fontSize: 13,
  py: 1.25,
  px: 2.5,
  boxShadow: "none",
  "&:hover": { boxShadow: "none" },
};

export const primaryBtnSx = actionBtnSx;

/** Outlined select dropdown consistent across map & stop selectors */
export const getSelectSx = () => ({
  fontSize: 13,
  borderRadius: "9px",
  background: tokens.surface,
  color: tokens.text,
  "& .MuiOutlinedInput-notchedOutline": { borderColor: tokens.border },
  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: tokens.borderStrong },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: tokens.accent,
    borderWidth: 1.5,
  },
});

/** Subtle gradient line separator between card sections */
export const getDividerSx = () => ({
  height: "1px",
  background: `linear-gradient(to right, transparent, ${tokens.border}, transparent)`,
});

/** Light grey info box used for status/detail rows inside cards */
export const getSectionBoxSx = () => ({
  p: 2,
  background: tokens.surface2,
  border: `1px solid ${tokens.border}`,
  borderRadius: "12px",
});

/** Uppercase eyebrow label above a panel section (kept for any residual use). */
export const getEyebrowSx = () => ({
  fontSize: 11,
  fontWeight: 600,
  color: tokens.text3,
  letterSpacing: "0.1em",
  textTransform: "uppercase",
});

/** Secondary/outlined button — kept for any residual use outside the phases. */
export const getSecondaryBtnSx = () => ({
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 600,
  fontSize: 13,
  py: 1.05,
  px: 1.75,
  whiteSpace: "nowrap",
  boxShadow: "none",
  color: tokens.text,
  background: tokens.surface,
  borderColor: tokens.border,
  "&:hover": {
    boxShadow: "none",
    background: tokens.surface2,
    borderColor: tokens.borderStrong,
  },
});
